import {
  BanknotesIcon,
  BuildingLibraryIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  DocumentTextIcon,
  InformationCircleIcon,
  PaperClipIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/outline'
import { INotification, NotificationType } from 'services'

/** Icon and label per notification type. A new backend type wants an entry here. */
export const NotificationTypeMeta: Record<NotificationType, { label: string; Icon: any }> = {
  task: { label: 'Tasks', Icon: ClipboardDocumentCheckIcon },
  loan: { label: 'Loans', Icon: DocumentTextIcon },
  message: { label: 'Messages', Icon: ChatBubbleLeftRightIcon },
  payment: { label: 'Payments', Icon: BanknotesIcon },
  condition: { label: 'Conditions', Icon: CheckCircleIcon },
  document: { label: 'Documents', Icon: PaperClipIcon },
  note: { label: 'Notes', Icon: PencilSquareIcon },
  servicing: { label: 'Servicing', Icon: BuildingLibraryIcon },
  system: { label: 'System', Icon: InformationCircleIcon },
}

export const getNotificationMeta = (type: string) =>
  NotificationTypeMeta[type as NotificationType] || NotificationTypeMeta.system

/**
 * Severity colouring for the row's icon badge. Opacity steps are kept on Tailwind's default scale
 * (10/20/...): this project's Tailwind silently emits no CSS for an off-scale modifier like /15.
 */
export const NotificationLevelClass: Record<string, string> = {
  info: 'bg-sky-100 text-sky-700 dark:bg-sky-400/20 dark:text-sky-300',
  success: 'bg-green-100 text-green-700 dark:bg-green-400/20 dark:text-green-300',
  warning: 'bg-amber-100 text-amber-700 dark:bg-amber-400/20 dark:text-amber-300',
  error: 'bg-red-100 text-red-700 dark:bg-red-400/20 dark:text-red-300',
}

export const getLevelClass = (level: string) => NotificationLevelClass[level] || NotificationLevelClass.info

/**
 * Where a row navigates to. The backend fills `link` for everything it raises; a captured toast has
 * none, so it falls back to the loan it was about, if any.
 */
export const getNotificationLink = (item: INotification) => {
  if (item.link) return item.link
  if (item.loanNumber) return `/loan_process/overview/${item.loanNumber}`
  return ''
}
